module.exports = __webpack_public_path__ + "static/media/photovoltaic.0c901471.jpg";